<template>
    <div class="mediaDetail-container">
        <headline :params="headLines" />
        <div class="mediaDetail-content">
            <div class="left-container">
                <div class="title">
                    <div class="left">
                        <i @click="back"></i>
                        <span>{{config.title}}</span>
                    </div>
                    <div @click="showCreate = true" class="right"></div>
                </div>

                <div class="search">
                    <div v-if="isTime" class="time">
                        <date-picker v-model="datePicker" range type="date" calendar-icon="none" :editable="false" :clearable="true" :shortcuts="false" confirm></date-picker>
                    </div>

                    <div v-else class="input">
                        <input v-model="keyword" @keydown.enter="addTag" placeholder="请输入要查询的内容" type="text">
                    </div>

                    <div @click="isTime = !isTime" class="search"></div>
                </div>

                <div v-if="tag.length > 0" class="tags">
                    <ul>
                        <li v-for="(item,index) in tag" :key="++index">
                            <span>{{item}}</span>
                            <i @click="delTag"></i>
                        </li>
                    </ul>
                </div>

                <div ref="list" class="list">
                    <ul>
                        <li :class="{on: listIndex == index}" @click="getDetail(hb_id, item.content_id, item.type);listIndex = index" v-for="(item, index) in list" :key="item.id">
                            <div class="content">
                                <div v-html="item.title" class="title"></div>
                                <div class="info">
                                    <span class="f">{{item.client_name}}</span>
                                    <span class="t">{{item.release_time}}</span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div :class="{'right-container': true, word: type == 'content', media: type != 'content'}">
                <articleDetail :info="info" v-if="type == 'content'"></articleDetail>
                <mediaDetail :info="info" v-else></mediaDetail>
            </div>
        </div>
        <transferBox :config="config" @submit="submit" @close="showCreate = false" :mediaList="mediaList" :transferBoxTitle="transferBoxTitle" v-if="showCreate"></transferBox>
    </div>
</template>

<script>
import { apis } from "@common/config";
import common from "@common/common";
import headline from "@components/headline";
import articleDetail from "@components/articleDetail";
import mediaDetail from "@components/mediaDetail";
import DatePicker from 'vue2-datepicker';
import transferBox from "@components/transferBox";

export default {
    components: {
        headline,
        DatePicker,
        articleDetail,
        mediaDetail,
        transferBox
    },
    watch: {
        datePicker: {
            deep: true,
            handler: function(n) {
                this.page.pageIndex = 1
                this.start = common.stampToTime(n[0])
                this.end = common.stampToTime(n[1])
                this.getList()
            }
        }
    },
    data() {
        return {
            listIndex: 0,
            hb_id: null,
            canLoad: true,
            showCreate: false,
            transferBoxTitle: '编辑看板',
            headLines: {
                title: "",
                showLink: false,
                filter: false
            },
            page: {
                page_count: 0,
                pageIndex: 1,
                pageSize: 10,
                total: 0
            },
            tag: [],
            datePicker: '',
            start: '',
            end: '',
            isTime: true,
            type: 'content',
            info: {

            },
            keyword: '',
            list: [],
            id: '',
            mediaList: [],
            config: {}
        }
    },
    methods: {
        back() {
            common.jump(`/media`, false);
        },
        submit(info) {
            common.myFetch(apis.editboard, info).then(res => {
                if(res){
                    this.showCreate = false
                    this.$toast(res)
                    this.getList()
                    this.getBoard(this.id)
                }
            })
        },
        getBoard(id) {
            let info = {
                board_id: id || ''
            }
            common.myFetch(apis.boardinfo, info).then(res => {
                if(res){
                    console.log(res)
                    res.detail.clients.forEach(item => {
                        item.selected = false;
                    });
                    this.config = res.detail
                }
            })
        },
        getMedias(type, keyword, board_id) {
            let info = {
                type: type || '',
                keyword: keyword || '',
                board_id: board_id || ''
            }
            common.myFetch(apis.medias, info).then(res => {
                if(res){
                    this.mediaList = res.list
                }
            })
        },
        delTag() {
            this.tag = []
            this.keyword = ''
            this.getList()
        },
        addTag() {
            this.tag = [this.keyword]
            this.keyword = ''
            this.page.pageIndex = 1
            this.getList()
        },
        getList() {
            let info = {
                id: this.id,
                page: this.page.pageIndex,
                pagesize: this.page.pageSize,
                start: this.start,
                end: this.end,
                keyword: this.tag.join(',')
            }
            common.myFetch(apis.sentimentnews, info).then(res => {
                res.list.forEach(el => {
                    el.minTitle = el.title.substring(0,46)
                })
                if(this.page.pageIndex - 0 === 1){
                    this.list = res.list;
                    this.canLoad = true;
                    if(res.list.length > 0){
                        this.hb_id = res.hb_id
                        this.getDetail(this.hb_id, res.list[0].content_id, res.list[0].type)
                    }
                }else{
                    if(res.list.length > 0){
                        this.list = this.list.concat(res.list);
                        this.canLoad = true;
                    }else{
                        this.canLoad = false;
                    }
                }
            })
        },
        getDetail(hbid, id, type) {
            console.log(hbid, id, type)
            let info = {
                hb_id: hbid,
                content_id: id
            }
            if(type === 'content'){
                common.myFetch(apis.boardcontent, info).then(res => {
                    if(res){
                        console.log(res)
                        if(res.detail.title.length > 46){
                            res.detail.minTitle = res.detail.title.substring(0,43)+'...'
                        }else{
                            res.detail.minTitle = res.detail.title
                        }
                        
                        this.info = res.detail
                        this.type = type

                        this.$nextTick(() => {
                            let articlePreviewContainerDom = document.getElementsByClassName("articlePreview-content")[0];
                            let imgDom = articlePreviewContainerDom.getElementsByTagName("video");
                            for (let index = 0; index < imgDom.length; index++) {
                                const element = imgDom[index];
                                let newDiv = document.createElement("div");
                                let materialDom = `
                                <div data-index="${index}" class="toMaterial">
                                    <i></i>
                                    <span>我的素材</span>
                                </div>
                                `
                                newDiv.className = 'videoContainer'
                                newDiv.innerHTML = materialDom
                                newDiv.appendChild(element.cloneNode(true));
                                element.parentNode.replaceChild(newDiv, element);
                            }

                            let toMaterialDom = document.getElementsByClassName('toMaterial')
                            console.log(toMaterialDom)
                            for (let index = 0; index < toMaterialDom.length; index++) {
                                toMaterialDom[index].addEventListener('click', () => {
                                let info = {
                                    url: imgDom[index].src,
                                    title: this.config.title
                                }

                                common.myFetch(apis.browserdownload, info).then((res) => {
                                    if(res){
                                    this.$toast(res)
                                    }
                                    // console.log(res)
                                })
                                })
                            }
                        })
                    }
                })
            }else{
                common.myFetch(apis.boardvideo, info).then(res => {
                    if(res){
                        console.log(res)
                        if(res.detail.title.length > 46){
                            res.detail.minTitle = res.detail.title.substring(0,43)+'...'
                        }else{
                            res.detail.minTitle = res.detail.title
                        }
                        this.info = res.detail
                        this.type = type
                    }
                })
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            var list = this.$refs.list;   // 获取滚动条的dom
            // console.log("距顶部"+scrollTop+"可视区高度"+windowHeight+"滚动条总高度"+scrollHeight);
            // console.log(list)
            list.onscroll = () => {
                var scrollTop = list.scrollTop;
                // 获取可视区的高度
                var windowHeight = list.clientHeight;
                // 获取滚动条的总高度
                var scrollHeight = list.scrollHeight;
                if(scrollTop+windowHeight>=scrollHeight - 200){
                    if(this.canLoad){
                        this.canLoad = false;
                        this.page.pageIndex ++;
                        this.getList();
                    }
                }
            }

            const oMeta = document.createElement('meta');
            oMeta.name = "referrer";
            oMeta.content = "no-referrer"
            document.getElementsByTagName('head')[0].appendChild(oMeta);
        });
    },
    created() {
        let id = this.$route.query.d
        this.id = id
        this.getList()
        this.getMedias('', '', id)
        this.getBoard(id)
        this.headLines.title = '媒体看板'
    }
}
</script>

<style lang="less" scoped>
    .mediaDetail-container {
        display: flex;
        flex-direction: column;
        width: 100%;

        .mediaDetail-content {
            display: flex;
            flex-direction: row;
            width: 100%;
            height: calc(100vh - 70px);
            overflow: hidden;

            .left-container {
                display: flex;
                flex-direction: column;
                width: 404px;
                height: 100%;
                background: #FAFBFC;
                padding-top: 30px;
                box-sizing: border-box;

                &>.title {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    padding: 0 20px;
                    box-sizing: border-box;
                    margin-bottom: 20px;

                    .left {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        i {
                            display: block;
                            width: 30px;
                            height: 30px;
                            background: url('../../assets/img/analysis/back.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            margin-right: 10px;
                            user-select: none;
                            cursor: pointer;
                        }

                        span {
                            font-size: 20px;
                            line-height: 30px;
                            color: #0B131F;
                            font-weight: bold;
                        }
                    }

                    .right {
                        display: block;
                        width: 22px;
                        height: 22px;
                        background: url('../../assets/img/analysis/edit.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                        user-select: none;
                        cursor: pointer;
                    }
                }

                &>.search {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 20px;
                    height: 30px;
                    box-sizing: border-box;
                    border-radius: 4px;
                    margin-bottom: 20px;

                    .input {
                        flex: 1;
                        height: 30px;
                        background: rgba(185, 195, 195, 0.2);
                        padding: 0 20px;
                        box-sizing: border-box;

                        input {
                            width: 100%;
                            height: 100%;
                            background: transparent;

                            &::placeholder {
                                color: #B9C3C3;
                            }
                        }
                    }

                    .time {
                        width: 320px;
                        height: 30px;
                    }

                    .search {
                        display: block;
                        min-width: 34px;
                        min-height: 30px;
                        background: url('../../assets/img/analysis/search.png') no-repeat;
                        background-position: center center;
                        background-size: 100% 100%;
                    }
                }

                &>.tags {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    padding: 0 20px;

                    ul {
                        display: flex;
                        flex-direction: row;
                        flex-wrap: wrap;

                        li {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            padding: 0 11px 0 20px;
                            height: 30px;
                            background: rgba(185,195,195,0.2);
                            margin: 0 10px 10px 0;

                            span {
                                display: block;
                                font-size: 14px;
                                line-height: 30px;
                                color: #0B131F;
                                margin-right: 10px;
                            }

                            i {
                                display: block;
                                width: 10px;
                                height: 10px;
                                background: url('../../assets/img/analysis/delIcon.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                user-select: none;
                                cursor: pointer;
                            }
                        }
                    }
                }

                &>.list {
                    width: 100%;
                    flex: 1;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: rgba(185,195,195,0.5);
                        border-radius: 2px;
                    }

                    ul {
                        display: flex;
                        flex-direction: column;

                        li {
                            padding: 0px 20px;
                            box-sizing: border-box;

                            &:hover {                              
                                background: rgba(185, 195, 195, 0.15);

                                .content {
                                    .title {
                                        color: #41B48C;
                                    }
                                }
                            }

                            &.on {
                                background: rgba(185, 195, 195, 0.15);

                                .content {
                                    .title {
                                        color: #41B48C;
                                    }
                                }
                            }

                            .content {
                                padding: 14px 0px;
                                border-bottom: 1px solid #DCDCDC;
                                box-sizing: border-box;
                                word-break: break-all;

                                .title {
                                    font-size: 16px;
                                    line-height: 24px;
                                    color: #050F0F;
                                    margin-bottom: 6px;
                                    font-weight: 500;
                                    display: -webkit-box;
                                    -webkit-line-clamp:2;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    -webkit-box-orient: vertical;
                                }

                                .info {
                                    display: flex;
                                    flex-direction: row;
                                    align-items: center;

                                    span {
                                        font-size: 12px;
                                        line-height: 17px;
                                        color: #829191;
                                        font-weight: bold;

                                        &.t {
                                            margin-left: 24px;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            .right-container {
                // flex: 1;
                width: calc(100vw - 404px);
                // height: 100%;

                &.word {
                    padding: 30px 20px 0;
                    box-sizing: border-box;
                }

                &.media {
                    display: flex;
                    justify-content: center;
                    height: 100%;
                    padding: 30px 0;
                    box-sizing: border-box;
                    overflow-y: auto;
                }
            }
        }
    }
</style>